import { zodResolver } from '@hookform/resolvers/zod';
import { Form } from '@web/components/ui/form';
import { TextareaAutosize } from '@web/components/ui/text-area-autosize';
import { useForm } from 'react-hook-form';
import { commentFormSchema, CommentFormType } from '../-types/comment-form';
import { Button } from '@web/components/ui/button';

export function CommentAddOrEditForm({
  comment,
  onSubmit,
}: {
  comment: CommentFormType;
  onClose: () => void;
  onSubmit: (data: CommentFormType) => Promise<void>;
}) {
  const form = useForm<CommentFormType>({
    resolver: zodResolver(commentFormSchema),
    defaultValues: comment,
  });

  const { isSubmitting } = form.formState;

  return (
    <Form {...form}>
      <form
        onSubmit={(e) => {
          void form.handleSubmit(onSubmit)(e);
        }}
      >
        <TextareaAutosize
          value={form.watch('content')}
          onChange={(e) => {
            form.setValue('content', e.target.value);
          }}
          required
          maxLength={1000}
        />

        <Button disabled={isSubmitting} className="mt-10">
          {isSubmitting ? 'Saving...' : 'Save'}
        </Button>
      </form>
    </Form>
  );
}
